import { Routes, RouterModule } from '@angular/router';
import { ConfirmDeactivateGuard } from 'src/commons/guards';
import { PlantPlanetScreenComponent } from './plant-planet.component';

const plantPlanetRoutes: Routes = [];

export const PlantPlanetRouter = RouterModule.forChild(plantPlanetRoutes);